import { useMemo } from 'react'

import EmailIcon from '@icons/EmailIcon'

import Badge from '@mui/material/Badge'
import IconButton from '@mui/material/IconButton'

import usePopover from '@shared/hooks/src/usePopover'

import { MentionsPopover } from '@pages/Mentions'
import { useMentions } from '@pages/Mentions/Mentions.hooks'

export default function Mentions({ size }) {
  const popover = usePopover()

  const { data: mentionsCache } = useMentions({ type: 'received', unreplied: true, mentioned_user_name: '' }, { enabled: false })

  const hasUnreplied = useMemo(() => {
    return (mentionsCache || []).some((mention) => !mention.repliedAt)
  }, [mentionsCache])

  return (
    <>
      <IconButton
        id="mentions-button"
        color="secondary"
        size={size}
        onClick={popover.handleOpen}
        ref={popover.anchorRef}
        aria-label="Mentions"
        data-testid="header-mentions"
      >
        <Badge color="error" variant="dot" invisible={!hasUnreplied} data-testid="header-mentions-badge" data-test-unread={hasUnreplied}>
          <EmailIcon style={{ fontSize: 18 }} />
        </Badge>
      </IconButton>
      <MentionsPopover anchorEl={popover.anchorRef.current} open={popover.open} onClose={popover.handleClose} />
    </>
  )
}
